export const Pages = {
  EVENTS: '/',
  EVENTS_ARCHIVE_LIST: '/archive',

  EVENT_INFO: '/event/:eventId',
  EVENT_SETTINGS: '/event/:eventId/settings',
  SCAN_RECEIPTS_LIST: '/event/:eventId/scan_receipts',
  SCAN_RECEIPT_PANEL: '/event/:eventId/scan_receipt/:id',

  CREATE_PAYMENTS_FROM_QR_CODE: '/event/:eventId/payment/create_qr_multiple',
  CREATE_PAYMENT_FROM_QR_CODE: '/event/:eventId/payment/create_qr',
  CREATE_PAYMENT: '/event/:eventId/payment/create',
  CREATE_REPAYMENT: '/event/:eventId/repayment/create',

  EDIT_PAYMENT: '/event/:eventId/payment/:id/edit',
  EDIT_REPAYMENT: '/event/:eventId/repayment/:id/edit',

  PAYMENT_INFO: '/event/:eventId/payment/:id',
  REPAYMENT_INFO: '/event/:eventId/repayment/:id',

  PROFILE: '/profile',
  INVITE: '/invite/:invite'
};

export const Panels = {
  ERROR: 'error',
  EVENT_INFO: 'eventInfo',
  EVENT_SETTINGS: 'eventSettings',
  SCAN_RECEIPTS_LIST_PANEL: 'scanReceiptsListPanel',
  SCAN_RECEIPT_PANEL: 'scanReceiptPanel',
  CREATE_PAYMENTS_FROM_QR_CODE_PANEL: 'createPaymentsFromQrCodePanel',
  CREATE_PAYMENT_FROM_QR_CODE_PANEL: 'createPaymentFromQrCodePanel',
  CREATE_PAYMENT_PANEL: 'createPaymentPanel',
  EDIT_PAYMENT_PANEL: 'editPaymentPanel',
  PAYMENT_INFO_PANEL: 'paymentInfoPanel',
  CREATE_REPAYMENT_PANEL: 'createRepaymentPanel',
  REPAYMENT_INFO_PANEL: 'repaymentInfoPanel',
  EDIT_REPAYMENT_PANEL: 'editRepaymentPanel',
  EVENTS_LIST: 'eventsList',
  EVENTS_ARCHIVE_LIST: 'eventsArchiveList',
  SELECT_DISTRIBUTION_TYPE: 'selectDistributionType',
  MAIN_PANEL: 'mainPanel',
  PROFILE_PANEL: 'profilePanel',
  INVITE_PANEL: 'invitePanel',
};

export const Views = {
  MAIN: 'main',
}

export const DISTRIBUTION_TYPE_EQUALLY = 'equally';
export const DISTRIBUTION_TYPE_VALUE = 'value';
export const DISTRIBUTION_TYPE_PARTS = 'parts';
